import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AlertCircleIcon, CheckCircle2Icon, InfoIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { buildCart } from '../../utils/pricing';
import { formatMoney, formatOfferAmount } from '../../utils/format';
const tones = {
  warn: {
    cls: 'border-i9-warnLine bg-i9-warnBg text-i9-warnInk',
    Icon: AlertCircleIcon
  },
  info: {
    cls: 'border-i9-infoLine bg-i9-infoBg text-i9-infoInk',
    Icon: InfoIcon
  },
  success: {
    cls: 'border-i9-greenLine bg-i9-green text-i9-greenInk',
    Icon: CheckCircle2Icon
  }
};
export function StepNotice() {
  const {
    state,
    cart,
    actions
  } = useProto();
  const amt = formatOfferAmount(state.config.amount);
  const previous = buildCart(state.config.amount, true).total;
  const content: Record<string, {
    tone: keyof typeof tones;
    title: string;
    body: string;
    action?: {
      label: string;
      onClick: () => void;
    };
  }> = {
    unavailable: {
      tone: 'warn',
      title: 'The Volunteer Registration Discount is no longer available',
      body: 'All discount opportunities for this program were claimed before we could reserve one for you. Your volunteer selection is still saved — thank you for volunteering!'
    },
    removed: {
      tone: 'info',
      title: 'Volunteer Registration Discount removed',
      body: `Your volunteer selection changed, so the ${amt} discount was removed. Your total is now ${formatMoney(cart.total)} (was ${formatMoney(previous)}).`
    },
    expired: {
      tone: 'warn',
      title: 'Your discount reservation expired',
      body: 'We held a Volunteer Registration Discount for you, but the hold ran out. Check again to see if an opportunity is still available.',
      action: {
        label: 'Check availability',
        onClick: actions.recheckHold
      }
    },
    'expired-rereserved': {
      tone: 'success',
      title: 'Good news — your discount is still available',
      body: `Your earlier hold expired, but an opportunity was still open, so the ${amt} discount has been applied again.`
    },
    'expired-unavailable': {
      tone: 'warn',
      title: 'Your discount reservation expired',
      body: 'All discount opportunities were claimed after your hold ran out, so the discount was removed from your cart. Your volunteer selection is still saved.'
    }
  };
  const n = state.notice ? content[state.notice] : null;
  return <AnimatePresence initial={false} data-id="element-342" data-mp="1fqazny7m7696">
      {n && state.notice && <motion.div key={state.notice} role="status" initial={{
      opacity: 0,
      y: -6
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className={`flex gap-3 rounded-lg border px-4 py-3 font-i9 ${tones[n.tone].cls}`} data-id="element-343" data-mp="1kom41tf54ok0">
          {React.createElement(tones[n.tone].Icon, {
        className: 'mt-0.5 h-5 w-5 shrink-0',
        'aria-hidden': true
      })}
          <div className="min-w-0" data-id="element-344" data-mp="3641qz1zq4usa">
            <p className="text-[14px] font-bold leading-snug" data-id="element-345" data-mp="uf3l258ipvt8">{n.title}</p>
            <p className="mt-1 text-[13px] leading-relaxed" data-id="element-346" data-mp="ugeog3y1x1jt">{n.body}</p>
            {n.action && <button type="button" onClick={n.action.onClick} className="mt-2.5 rounded bg-i9-steel px-3.5 py-2 text-[13px] font-semibold text-white transition-colors hover:bg-i9-steelDark" data-id="element-347" data-mp="phv427z3vxtk">
                {n.action.label}
              </button>}
          </div>
        </motion.div>}
    </AnimatePresence>;
}